import { Button } from "../components/StyledElements";
export const NodeCard = ({ title, description, children, style = {}, onAdd = () => { } }) => {
  return (
    <div style={{ border: "1px solid var(--content-item-border-color)", borderRadius: "8px", padding: "16px", backgroundColor: "var(--main-bg)", width: "190px", ...style }}>
      <h3 style={{ fontSize: "16px", textDecoration: "underline", fontWeight: "700", color: "var(--main-font-color)", textAlign: "center" }}>{title}</h3>
      <p style={{ color: "var(--main-font-color)" }}>{description}</p>
      {children}

      <div style={{ marginTop: "20px", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Button style={{ marginTop: "auto" }} onClick={onAdd}>+ Add</Button>
      </div>
    </div>
  );
};
